import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedLoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loadingSubject.asObservable();

  get isLoadingValue(): boolean {
    return this.loadingSubject.getValue();
  }

  setLoading(): void {
    this.loadingSubject.next(true);
  }

  clearLoading(): void {
    this.loadingSubject.next(false);
  }
}
